import _ from 'lodash';
import {GetterTree} from 'vuex';
import {EmployeeStateConstant, MemberStateConstant} from '../constants';
import EcCommon from '../../../types/ec/ecCommon';
import EcMemberSearch from '../../../types/ec/ecMemberSearch';
import LtFramework from '../../../types/lt/ltFramework';
export const AlertNotificationGetters: GetterTree<LtFramework.IAlertNotificationState, LtFramework.IRootState> = {
};

export const ClubLocationsGetters: GetterTree<EcCommon.IClubLocationsState, LtFramework.IRootState> = {
	getClubs: (state: EcCommon.IClubLocationsState) => {
		const clubs: EcCommon.IClub[] = [];
		_.forEach(state.countries, (country) => {
			_.forEach(country.StateProvinces, (stateProvince) => {
				_.forEach(stateProvince.Clubs, (club) => {
					clubs.push(club);
				});
			});
		});

		return clubs;
	},
	getClubObjects: (state: EcCommon.IClubLocationsState) => {
		const clubObjects: EcCommon.IMultiSelctGroupChoices[] = [];
		_.forEach(state.countries, (country) => {
			_.forEach(country.StateProvinces, (stateProvince) => {
				clubObjects.push({
					Name: country.Name === 'Canada' ? 'Canada' : stateProvince.Name,
					Options: _.map(stateProvince.Clubs, (club) => {
						return {
							Name: club.Name,
							Value: club.ClubId,
							IsSelected: club.Selected,
						};
					}),
				});
			});
		});

		return clubObjects;
	},
};

export const EmployeeProfileGetters: GetterTree<LtFramework.IEmployeeProfileState, LtFramework.IRootState> = {
	getIsValid: (state: LtFramework.IEmployeeProfileState) => {
		return state && state.employeeProfile && state.employeeProfile.partyId > 0 && state.employeeProfile.employeeDetails && state.employeeProfile.employeeDetails.employeeId > 0 && state.employeeProfile.employeeState !== EmployeeStateConstant.unauthenticated;
	},
};

export const MemberSearchGetters: GetterTree<EcMemberSearch.IState, LtFramework.IRootState> = {
};

export const ProfileGetters: GetterTree<LtFramework.IProfileState, LtFramework.IRootState> = {
	getIsValid: (state: LtFramework.IProfileState) => {
		return state && state.profile && state.profile.partyId > 0 && (state.profile.memberDetails.isEmployee || state.profile.memberDetails.memberId > 0) && state.profile.memberState !== MemberStateConstant.unauthenticated;
	},
};

export const UrlGetters: GetterTree<LtFramework.IUrlState, LtFramework.IRootState> = {
	getGlobalPageDriverUrl: (state: LtFramework.IUrlState) => (section: string, page: string) => {
		if (!section) {
			throw new Error('Section is not defined');
		}

		if (!page) {
			throw new Error('Page is not defined');
		}

		if (!state.url.globalPageDrivers[section]) {
			throw new Error('Section ' + section + ' doesn\'t exist in global page drivers');
		}

		if (!state.url.globalPageDrivers[section][page]) {
			throw new Error('Page ' + page + ' doesn\'t exist in global page drivers');
		}

		const url = state.url.globalPageDrivers[section][page];

		return url;
	},
};
